// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.download.DownloadStatusObject
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DownloadStatus } from "abweb/dto/generated/download/DownloadStatus";
export class DownloadStatusObject {
  static createDownloadStatusObject(bytesWritten, status) {
    const retVal = new DownloadStatusObject();
    retVal.initDownloadStatusObject(bytesWritten, status);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createDownloadStatusObject factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DownloadStatusObject";
  }
  initFromJson(json, deserializeContext) {
    this.initDownloadStatusObject(json.bytesWritten, json.status != null ? DownloadStatus.fromJson(json.status) : null);
  }
  initDownloadStatusObject(bytesWritten, status) {
    this._bytesWritten = bytesWritten;
    this._status = status;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["bytesWritten"] = this._bytesWritten;
    retVal["status"] = this._status;
    return retVal;
  }
  get bytesWritten() {
    return this._bytesWritten;
  }
  set bytesWritten(value) {
    this._bytesWritten = value;
  }
  get status() {
    return this._status;
  }
  set status(value) {
    this._status = value;
  }
}
//# sourceMappingURL=DownloadStatusObject.js.map
